import { DependencyUsage } from '@modules/Dependencies/api/models/dependency-usage.model';
import React from 'react';
import ReactDOM from 'react-dom';
import { useAngularEventOn } from '../../../../hooks/useAngularEventOn';

// utils
import { angularEmit } from '../../../../utils/angularBridge';

// components
import DepsInfo from './DepsInfo';

// state
import useAppState from './useAppState';
import { makeTransitionLinkParams } from './utils/transitionLinkParamsBuilder';

export const DependenciesSearch = () => {
  const {state, actions} = useAppState();

  useAngularEventOn('react:show-dep-used-in', (e: any, dataSource: any) => {
    actions.selectDataSource(dataSource);
  });

  const handleItemClickFn = (item: DependencyUsage) => {
    const params = makeTransitionLinkParams(item);
    angularEmit('angular:transition-to-url', params);
  };

  return (
    <>
      {
        state.isOpen && state.selectedDataSource && document.querySelector('.dependencies-body')
          ?
          ReactDOM.createPortal(
            <DepsInfo
              selectedDataSource={state.selectedDataSource}
              onClose={actions.close}
              onItemClick={handleItemClickFn}
            />,
            document.querySelector('.dependencies-body') as Element
          )
          : null
      }
    </>
  );
};
